// PVQ Dropdown values
export const foreignBusinessAffairsFamilyOptions = [
  'Myself',
  'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
  'Person with whom you\'re in a committed, spouse-like relationship',
  'Parent',
  'Stepparent',
  'Child (including adopted/foster)',
  'Stepchild',
  'Sibling',
  'Stepsibling',
  'Half-sibling',
  'Parent-in-law',
  'Guardian',
];

// PVQ Dropdown values
export const foreignBusinessAffairsRelationshipOptions = [
  'Friend',
  'Schoolmate',
  'Neighbor',
  'Work Associate',
  'Landlord',
  'Other',
];

// PVQ Dropdown values
export const foreignBusinessAffairsRoleOptions = [
  'I owned the business',
  'I co-owned the business',
  'I was a business consultant',
  'Other',
];

// PVQ Dropdown values
export const foreignBusinessAffairsAgencyOptions = [
  'Military or Armed Forces',
  'Intelligence Service',
  'Security Service',
  'Diplomatic Service',
  'Embassy',
  'Consulate',
  'Other',
  'I don\'t know',
];

// PVQ Dropdown values
export const foreignBusinessAffairsSponsorshipReasonOptions = [
  'So they could attend school in the U.S.',
  'So they could work in the U.S.',
  'So they could pursue permanent U.S. residency',
  'Other',
];
